import { observable } from "mobx";

import { ApiConnector } from "../api/api-connector";
import { DataModel } from "./data-model";

export class APIDataModel<T extends object = any> extends DataModel<T> {
  @observable accessor loading = false;
  private readonly fetchData: () => Promise<T[]>;

  // `fetchData` is assigned by hand rather than as a constructor parameter
  // property — see the note in `features/admin/users/users.ts`.
  constructor(api: ApiConnector, fetchData: () => Promise<T[]>) {
    super([], api.permissions, api.requireUserUUID());
    this.fetchData = fetchData;
  }

  async refresh() {
    this.loading = true;
    try {
      this.data = await this.fetchData();
      this.init();
    } finally {
      this.loading = false;
    }
  }
}
